module.exports = __webpack_public_path__ + "img/testpaper_eye_open.fbcc5724.svg";